import { render, staticRenderFns } from "./GDPRConsent.vue?vue&type=template&id=ab1daa7c&"
import script from "./GDPRConsent.vue?vue&type=script&lang=js&"
export * from "./GDPRConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports